// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
<div style="height: 100%">
  <v-toolbar dark dense class="obspanel-toolbar">
    <v-btn icon to="/p">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
  </v-toolbar>

  <v-container fluid style="height: 100%">
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="text-h5 mb-0">My Profile</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <form action="">
        <v-row row justify="space-between">
          <v-col><v-text-field label="First Name" disabled v-model="$store.state.noctuaSky.user.first_name"></v-text-field></v-col>
          <v-col><v-text-field label="Last Name" disabled v-model="$store.state.noctuaSky.user.last_name"></v-text-field></v-col>
          <v-col cols="2">
            <v-btn icon ripple to="/p/users/update-user-infos">
              <v-icon class="grey--text text--lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-text-field name="input-email" disabled label="Email" v-model="$store.state.noctuaSky.user.email"></v-text-field>
        <v-row justify="space-between">
          <v-col><v-text-field label="Password" disabled type="password" value="xxxxxxxx" autocomplete="no"></v-text-field></v-col>
          <v-col cols="2">
            <v-btn icon ripple to="/p/users/change-password">
              <v-icon class="grey--text text--lighten-1">mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-dialog v-model="showDeleteAccountDialog" width="600">
          <template v-slot:activator="{ on }">
            <v-btn small class="red--text darken-1" v-on="on">Delete Account</v-btn>
          </template>
          <v-card style="height: 280px" class="secondary white--text">
            <v-card-title primary-title>
              <div>
                <h3 class="text-h5 mb-0">Delete my account</h3>
              </div>
            </v-card-title>
            <v-card-text style="width:100%;">
              Deleting your NoctuaSky account is permanent and cannot be undone. Before deleting your account, please keep in mind that:
              <ul>
                <li>Deleting your account will irremediably delete all observations, personal informations and pictures you created from our servers.</li>
                <li>Observations you shared with public links won't be accessible anymore.</li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn class="red--text darken-1" text @click.native="deleteAccount()">Yes, delete all</v-btn>
                <v-btn class="blue--text darken-1" text @click.native="showDeleteAccountDialog = false">Cancel!</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>

</div>
</template>

<script>
import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      showDeleteAccountDialog: false
    }
  },
  methods: {
    deleteAccount: function () {
      var that = this
      NoctuaSkyClient.users.deleteAccount().then(res => {
        that.showDeleteAccountDialog = false
        that.$router.replace('/p')
      })
    }
  },
  computed: {
  }
}
</script>

<style>
ul {
  padding-left: 30px;
}
</style>
